import $ from 'jquery';
import Swal from 'sweetalert2'
import Nette from '../js/form/index.js';
import 'nette.ajax.js';
import 'adt-nette-ajax';
import 'ublaboo-datagrid';

//
// Modular vendor JS files
//
import 'bootstrap';
import {Modal} from "bootstrap"
//
import AdtJsComponents from 'adt-js-components';

import Select2Component from "../js/Select2"
import ComponentLoader from "./ComponentLoader";

// Lightbox (pro zobrazení obrázků)
import 'lightbox2';
// GSAP pro různé animace
//Swiper pro slider
import {initNumberInput} from "./NumberInput";

import "select2"
import AOS from "aos"

import {Html5QrcodeScanner} from "html5-qrcode"
import {Html5Qrcode} from "html5-qrcode"

window.$ = $;
window.jquery = $;
window.jQuery = $;
window.initNumberInputHelper = initNumberInput;
window.Modal = Modal;
window.Swal = Swal;
window.Html5QrcodeScanner = Html5QrcodeScanner;
window.Html5Qrcode = Html5Qrcode;
window.AOS = AOS;

import "trumbowyg";
import "formBuilder"

Nette.initOnLoad();
window.Nette = Nette;

$.nette.init();

AdtJsComponents.init('global-example-form', 'Components/Forms/ExampleForm');
AdtJsComponents.initCurrencyInput();
AdtJsComponents.initDateInput();
Select2Component.initSelect2();
ComponentLoader.initRecaptcha();

AdtJsComponents.initSubmitForm();

$.nette.ext('myExtension', {
	success: function(payload) {
		Select2Component.initSelect2();
	}
});